import { useState, useEffect } from 'react';

type CaseStudyIndex = Record<string, string[]>;

let cachedIndex: CaseStudyIndex | null = null;

export const useCaseStudyIndex = (serviceSlug: string) => {
  const [slugs, setSlugs] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (cachedIndex) {
      setSlugs(cachedIndex[serviceSlug] || []);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(`${process.env.PUBLIC_URL}/content/case-studies-index.json`)
      .then((res) => {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then((index: CaseStudyIndex) => {
        cachedIndex = index;
        setSlugs(index[serviceSlug] || []);
      })
      .catch(() => {
        setSlugs([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [serviceSlug]);

  return { slugs, loading };
};
